
export class Register {
firstName :string;
lastName :string;
userid :number;
emailId  :string;
password :string;
phoneNumber :string;
companyname :string;
universityId :number=123;
roleId :number=1;
pincode :string;
city :string;
state :string;
country :string;
address :string;
}